<template>
    <b-row class="mt-4">
         <b-col lg="3">
            <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                :placeholder="$i18n.locale()=='kz' ? 'Іздеу' : 'Поиск'"
                ></b-form-input>
        </b-col>
        <b-col lg="3">
            <select
                @change="sysChange()" 
                required id="levelId" class="form-control" v-model="levelId">
                <option :value=0>{{ $t('comboChooseText') }}</option>
                <option v-for="(l,li) in levels" :value=l.levelId :key="li">{{ $i18n.locale()=='kz' ? l.levelName : l.levelNameRu }}</option>
            </select>
        </b-col>
        <b-col lg="3">
            <select
                @change="sysChange()" 
                required id="statusId" class="form-control" v-model="statusId">
                <option :value=0>{{ $t('comboChooseText') }}</option>
                <option v-for="(l,li) in statuses" :value=l.statusId :key="li">{{ $i18n.locale()=='kz' ? l.statusName : l.statusNameRu }}</option>
            </select>
        </b-col>
        <b-col lg="3" class="pt-3 text-right">
            <strong>
            {{$i18n.locale()=='kz' ? 'Жалпы саны:' : 'Общее число'}}
            </strong> {{totalRows}}  
        </b-col>
        <b-col lg="12">
              <b-table 
                ref="pTable"
                striped hover selectable
                :items="projectProvider" 
                :fields="fields"
                :busy.sync="isBusy"
                :current-page="currentPage"
                :per-page="perPage"
                table-variant='light'
                :filter="filter"
                :select-mode="selectMode"
                response
                @row-selected="onRecordSelected"
                @row-dblclicked="handleRowDoubleClick"
                >
                <template v-slot:cell(ID)="{ rowSelected }">
                <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                </template>
                </template>
                <template v-slot:table-busy>
                <div class="text-center text-info my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Жүктелуде...</strong>
                </div>
                </template>
                
                <template #head(levelName)="data">
                    <div class="text-left text-info ">{{$t(data.label)}}</div>
                </template>
                <template #head(locationName)="data">
                    <div class="text-left text-info ">{{$t(data.label)}}</div>
                </template>
                <template #head(pNumber)="data">
                    <div class="text-left text-info ">{{$t(data.label)}}</div>
                </template>
                <template #head(pKm)="data">
                    <div class="text-left text-info ">{{$t(data.label)}}</div>
                </template>
                <template #head(pDate)="data">
                    <div class="text-left text-info ">{{$t(data.label)}}</div>
                </template>
                <template #head(endDate)="data">
                    <div class="text-left text-info ">{{$t(data.label)}}</div>
                </template>
                <template #head(pAddress)="data">
                    <div class="text-left text-info ">{{$t(data.label)}}</div>
                </template>
                <template #head(orgNames)="data">
                    <div class="text-left text-info ">{{$t(data.label)}}</div>
                </template>
                <template #head(budget)="data">
                    <div class="text-left text-info ">{{$t(data.label)}}</div>
                </template>
                <template #head(pPrice)="data">
                    <div class="text-left text-info ">{{$t(data.label)}}</div>
                </template>
                <template #head(actions)="data">
                    <div class="text-left text-info ">{{$t(data.label)}}</div>
                </template>
               
                <template v-slot:cell(orgNames)="row">
                    <b-badge variant="success" v-for="(o,oi) in row.item.orgNames.split(',')" class="mr-2" :key="oi">
                        {{o}}
                    </b-badge>
                </template>
                <template v-slot:cell(budget)="row">
                    <b-button  
                        @click="historyModal(row.item.pId)" 
                        variant="outline-secondary" class="mr-1 mb-1" size="sm">
                        {{$t("project.budgetNotes")}}
                    </b-button>
                    <!-- <b-button  
                        @click="workPlanModal(row.item.pId)" 
                        variant="outline-success" class="mr-1 mb-1" size="sm">
                        {{$t("project.prjectWorkPlan")}}
                    </b-button> -->
                    <!-- <b-button  
                        variant="outline-success" class="mr-2 mb-1" size="sm">
                        {{$t("project.usedBudget")}}
                    </b-button> -->
                </template>
                <template v-slot:cell(actions)="row">
                    <b-button  
                        v-if="row.item.stCode=='proccess'"
                        @click="chageStatus('done',row.item.pId)"
                        variant="outline-primary" class="mr-1 mb-1" size="sm">
                        {{$t("project.done")}}
                    </b-button>
                    <b-button  
                        v-if="row.item.stCode=='proccess'"
                       
                        variant="outline-danger" class="mr-1 mb-1" size="sm">
                        {{$t("project.decline")}}
                    </b-button>
                </template>
            </b-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
            ></b-pagination>
        </b-col>
        <BudgetNotes :pId="pId"></BudgetNotes>
        <ProjectFile :pId="pId"></ProjectFile>
        <WorkPlanModal :pId="pId"></WorkPlanModal>
    </b-row>
</template>
<script>
import axios from 'axios';
import {apiDomain,getHeader} from "@/config/config";
import vue from 'vue';
import BudgetNotes from '@/components/dag/BudgetNotes';
import ProjectFile from '@/components/dag/ProjectFile';
import WorkPlanModal from '@/components/dag/WorkPlanModal';
export default {
    name:"Projects",
    components:{
        BudgetNotes,
        ProjectFile,
        WorkPlanModal
    },
    data(){
        return {        
            fields: [
                {
                    key: 'pId',
                    label: 'ID',
                },
                {
                    key:"levelName",
                    label: 'prject.levelName',
                },
                {
                    key: 'locationName',
                    label: 'prject.locationName',
                },
                {
                    key: 'pNumber',
                    label: 'prject.pNumber',
                },
                {
                    key:"pPrice",
                    label: 'prject.pPrice',
                },
                {
                    key:"pKm",
                    label: 'prject.pKm',
                },
                {
                    key:"pDate",
                    label: 'prject.pDate',
                },
                {
                    key:"pAddress",
                    label: 'prject.pAddress',
                },
                {
                    key:"orgNames",
                    label: 'prject.ortNames',
                },
                {
                    key:"budget",
                    label: 'prject.bActions',
                },
                {
                    key:"actions",
                    label: 'prject.Actions',
                },
            ],
            isBusy:false,
            totalRows:0,
            currentPage: 1,
            perPage: 20,
            tableVariant:'light',
            filter:"",
            selectMode:'single',
            selectedRows:[],
            levelId:0,
            statusId:0,
            levels:[],
            statuses:[],
            pId:0
        }
    },
    methods:{
        handleRowDoubleClick(row) {
            this.pId=row.pId;
            this.$bvModal.show("fileModal");
        },
        historyModal(pId){
            this.pId=pId;
            this.$bvModal.show("budgetNoteModal");
        },
        workPlanModal(pId){
            this.pId=pId;
            this.$bvModal.show("workPlanModal");
        },
        sysChange(){
            this.$refs.pTable.refresh();  
        }, 
        onRecordSelected(items){
            this.selectedRows=items;
        },
        
        projectProvider(ctx){
            //alert("yes");
            ctx.levelId=this.levelId;
            ctx.statusId=this.statusId;
            this.isBusy = false
            let promise = axios.post(apiDomain+'/p/listproject',ctx,{headers:getHeader()});
                return promise.then((response) => {
                const result = response.data;
                this.isBusy = false
                this.totalRows=result.recordCount;
                //alert(JSON.stringify(result));
                return(result.items)
            }).catch(error => {
                this.isBusy = false
                return []
            })
        },
        projectLevels(){
            axios.post(apiDomain+'/p/listlevel',{},{headers:getHeader()})
            .then(response=>{
                this.levels=response.data;
            })
            .catch(error => {
                alert(error.message);
            })     
        },
        projectStatuses(){
            axios.post(apiDomain+'/p/liststatus',{},{headers:getHeader()})
            .then(response=>{
                this.statuses=response.data;
                let statusId = this.statuses.filter(st=>st.code=='proccess')[0].statusId;
                this.statusId=statusId;
                this.sysChange();

            })
            .catch(error => {
                alert(error.message);
            })     
        },
        chageStatus(stCode,pId){
            let warn = confirm(vue.i18n.translate('system.confirmMsg'));
            if (warn){
                let statusId = this.statuses.filter(st=>st.code==stCode)[0].statusId;
                
                axios.post(apiDomain+'/p/changestatus',{"statusId":statusId,"pId":pId},{headers:getHeader()})
                .then(response=>{
                    this.sysChange();
                })
                .catch(error => {
                    alert(error.message);
                })    
            }
            
        },
    },
    created(){
        this.projectLevels();
        this.projectStatuses();
    }   
}
</script>
